import useAppRouter from '../../hooks/useAppRouter';
import useProductEnabledByChannelSource from 'canvas_states/config/useProductEnabledByChannelSource';

const useOnboardCallback = () => {
  const { callbackUrl } = useAppRouter().states;
  const { isOnboardUpgradeEnabled } = useProductEnabledByChannelSource().states;

  return {
    states: {
      showOnboardBanner: isOnboardUpgradeEnabled && Boolean(callbackUrl),
      callbackUrl,
    },
  };
};

export default useOnboardCallback;
